import React from 'react';

const MinisiteMessageListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/minisite/messages',
      exact: true,
      component: React.lazy(() => import('./minisite_message_list'))
    }
  ]
};

const MinisiteMessageAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/minisite/messages/create',
      exact: true,
      component: React.lazy(() => import('./minisite_message_create'))
    }
  ]
};

const MinisiteMessageEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/minisite/messages/edit/:id',
      exact: true,
      component: React.lazy(() => import('./minisite_message_edit'))
    }
  ]
};

export {
  MinisiteMessageListConfig,
  MinisiteMessageAddConfig,
  MinisiteMessageEditConfig
};
